interface FieldProps {
  id: string;
  label: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

export const inputClass =
  'w-full rounded-full border border-neutral-300 bg-white px-5 py-3.5 text-[15px] text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 aria-[invalid=true]:border-secondary-500';

export default function Field({ id, label, error, children, className = '' }: FieldProps) {
  return (
    <div className={`flex flex-col gap-1.5 min-w-0 ${className}`}>
      <label htmlFor={id} className="text-sm text-foreground-600">{label}</label>
      {children}
      {error && (
        <span id={`${id}-err`} className="text-xs text-secondary-700">
          {error}
        </span>
      )}
    </div>
  );
}
